import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PinPanelService {
  private panelOpenedSource = new BehaviorSubject<number | null>(null);
  panelOpened$ = this.panelOpenedSource.asObservable();

  constructor() {}

  openPanel(panelId: any) {
    this.panelOpenedSource.next(panelId);
  }

  closeAllPanels() {
    this.panelOpenedSource.next(null);
  }
}
